import React, { useCallback, useEffect, useState } from "react"
import { MdEmail, MdRefresh } from "react-icons/md"
import { toast } from "react-toastify"
import Modal from "../index"
import Button from "../../Form/Button"
import api from "../../../services/api"
import { maskDate } from "../../../utils/formatter"
import styles from "./modalTransactions.module.css"

const statusDetails = delivery => {
    if (delivery.status === "bounced") return ["Não entregue", "danger"]
    if (delivery.status === "failed") return ["Falhou", "danger"]
    if (delivery.status === "complained") return ["Marcado como spam", "danger"]
    if (delivery.status === "suppressed") return ["Suprimido", "danger"]
    if (delivery.first_clicked_at) return ["Clicou", "success"]
    if (delivery.first_opened_at) return ["Abriu", "success"]
    if (delivery.delivered_at) return ["Entregue", "success"]
    return ["Enviado ao provedor", "pending"]
}

const eventLabels = { "billing.charge": "Cobrança", "billing.first_payment": "Primeiro pagamento", "billing.invoice": "Nota Fiscal" }

const ModalFinancialEmailHistory = ({ accountId, transactionId, closeModal }) => {
    const [deliveries, setDeliveries] = useState([])
    const [loading, setLoading] = useState(true)

    const load = useCallback(() => {
        setLoading(true)
        api.get(`/accounts/${accountId}/transactions/${transactionId}/email-deliveries`)
            .then(response => setDeliveries(response.data?.data || []))
            .catch(error => toast.error(error?.response?.data?.message || "Não foi possível carregar os envios."))
            .finally(() => setLoading(false))
    }, [accountId, transactionId])

    useEffect(load, [load])

    return <Modal icon={<MdEmail />} title="Histórico de envios" description="Acompanhamento individual informado pelo provedor de e-mail." closeModal={closeModal} fitContent={true}>
        <div className={styles.deliveryHistory}>
            <div className={styles.deliveryHistoryHeader}><span>{deliveries.length} entrega{deliveries.length === 1 ? "" : "s"}</span><Button type="button" variant="secondary" size="sm" fullWidth={false} onClick={load}><MdRefresh /> Atualizar</Button></div>
            {loading && <div className={styles.emailEmpty}>Atualizando histórico...</div>}
            {!loading && !deliveries.length && <div className={styles.emailEmpty}>Ainda não há envios rastreados para este lançamento.</div>}
            {!loading && deliveries.map(delivery => {
                const [status, tone] = statusDetails(delivery)
                const eventDate = delivery.first_clicked_at || delivery.first_opened_at || delivery.delivered_at || delivery.complained_at || delivery.unsubscribed_at || delivery.bounced_at || delivery.failed_at || delivery.submitted_at || delivery.created_at
                return <article className={styles.deliveryCard} key={delivery._id}>
                    <div><strong>{delivery.recipient?.name || delivery.recipient?.email}</strong><span>{delivery.recipient?.email}</span><small>{eventLabels[delivery.event_key] || "E-mail financeiro"} · {eventDate ? maskDate(eventDate, true) : "Processando"}</small></div>
                    <span className={`${styles.deliveryStatus} ${styles[`delivery${tone}`]}`}>{status}</span>
                    {delivery.error && <p>{delivery.error}</p>}
                </article>
            })}
        </div>
    </Modal>
}

export default ModalFinancialEmailHistory
